import { Badge, Card } from '@warp-ds/react';
import styles from './FeaturedAdsCarousel.module.css';

export type FeaturedAd = {
    itemId: number;
    heading: string;
    imageUrl: string;
    locality: string | null;
    pricePerNight: number | null;
    availableNightsNext60: number;
    noOfBedrooms?: number;
    sleepingCapacity?: number;
    adType?: string;
};

type FeaturedAdCardProps = {
    ad: FeaturedAd;
};

const makeSrcSet = (url: string) => `${url.replace('/default/', '/640x480c/')} 640w, ${url.replace('/default/', '/320x240c/')} 320w`;

const applyImageRule = (url: string, rule: string) => url.replace('/default/', rule);

export const FeaturedAdCard = ({ ad }: FeaturedAdCardProps) => {
    const adUrl = `/reise/feriehus-hytteutleie/ad.html?finnkode=${ad.itemId}`;
    const isPrivate = ad.adType === 'private';

    return (
        <article className={styles.card}>
            <a
                href={adUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${ad.heading} (åpnes i ny fane)`}
                className="no-underline text-current hover:no-underline">
                <Card>
                    <img
                        className="h-144 w-full object-cover"
                        src={applyImageRule(ad.imageUrl, '/480w/')}
                        srcSet={makeSrcSet(ad.imageUrl)}
                        alt={ad.heading}
                        sizes="(min-width: 768px) 280px, 80vw"
                        loading="lazy"
                    />
                    {isPrivate ? (
                        <Badge variant="info" position="top-left" className="px-8 gap-4">
                            Enkel bestilling
                        </Badge>
                    ) : (
                        // biome-ignore lint/complexity/noUselessFragments: Warp Card requires Element children
                        <></>
                    )}
                    <div className="p-16">
                        {ad.locality && <p className="text-12 text-gray-500 truncate mb-0">{ad.locality}</p>}
                        <h3 className="truncate text-16 font-normal text-gray-800 mt-2">{ad.heading}</h3>
                        {ad.pricePerNight != null && (
                            <p className="text-16 font-bold mt-8 mb-0">Fra {ad.pricePerNight.toLocaleString('nb-NO')} kr / natt</p>
                        )}
                        <p className="text-14 text-gray-500 mt-4 mb-0">
                            {ad.noOfBedrooms != null && <>{ad.noOfBedrooms} soverom</>}
                            {ad.noOfBedrooms != null && ad.sleepingCapacity != null && (
                                <>
                                    {' '}
                                    <span className="text-gray-500" aria-hidden="true">
                                        &bull;
                                    </span>{' '}
                                </>
                            )}
                            {ad.sleepingCapacity != null && <>{ad.sleepingCapacity} sengeplasser</>}
                            {(ad.noOfBedrooms != null || ad.sleepingCapacity != null) && ad.adType && (
                                <>
                                    {' '}
                                    <span className="text-gray-500" aria-hidden="true">
                                        &bull;
                                    </span>{' '}
                                </>
                            )}
                            {ad.adType && <>{isPrivate ? 'Privat' : 'Bedrift'}</>}
                        </p>
                    </div>
                </Card>
            </a>
        </article>
    );
};
